export const deliveryAnalyticsConstants = {
    errors: {
        fetchFailed: "Failed to load delivery analytics.",
        genericError: "Something went wrong.",
    },
};
